import { memo, useCallback, useState, type ReactNode, type MouseEvent } from 'react';
import { MoreVert } from '@mui/icons-material';
import { ClickAwayListener, IconButton, Menu, styled, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    marginTop: theme.spacing(1),
    minWidth: 180,
    boxShadow: '0 4px 20px rgba(43,54,116,0.12)',
  },
}));

const MobileHeaderMenuBase = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <ClickAwayListener
      onClickAway={(event) => {
        event.stopPropagation();
        handleClose();
      }}>
      <>
        <Tooltip title={t('common.options')}>
          <IconButton
            aria-label={t('common.options')}
            onClick={handleOpen}
            size="medium"
            sx={{ border: '1px solid', borderColor: 'secondary.dark', borderRadius: '10px', p: '7px' }}>
            <MoreVert fontSize="small" />
          </IconButton>
        </Tooltip>
        <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={handleClose}>
          {children}
        </StyledMenu>
      </>
    </ClickAwayListener>
  );
};

export const MobileHeaderMenu = memo(MobileHeaderMenuBase) as typeof MobileHeaderMenuBase;
